import React, { useEffect, useState } from "react";
import axios from "axios";
import calendarIcon from "../../assets/document/icons/calendar-icon.png";
import legalIcon from "../../assets/document/icons/legal-icon.png";
import brochureIcon from "../../assets/document/icons/brochure-icon.png";
import styles from "./styles/document.module.css";

const DocumentRM = () => {
  const [documentsData, setDocumentsData] = useState(null);
  const apiBase = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${apiBase}/documents?type=documents`)
      .then((res) => {
        const grouped = {
          monthly_newsletter: [],
          Legal_documents: [],
          Company_brochure: [],
          Annual_reports: {},
        };

        res.data.forEach((doc) => {
          const { subType, title, path } = doc;

          if (subType === "Annual_reports") {
            grouped.Annual_reports[title] = path;
          } else if (grouped[subType]) {
            grouped[subType].push({ title, path });
          }
        });

        setDocumentsData(grouped);
      })
      .catch((error) => console.error("Error fetching documents:", error));
  }, [apiBase]);

  if (!documentsData) return <div>Loading...</div>;

  const { monthly_newsletter, Legal_documents, Company_brochure, Annual_reports } = documentsData;

  const monthsForYear = {
    "2024": ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"],
    "2025": ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"],
    "2026": ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
  };

  const newsletterMap = {};
  monthly_newsletter.forEach((entry) => {
    const [month, year] = entry.title.toUpperCase().split(" ");
    if (!year || !month) return;

    if (!newsletterMap[year]) newsletterMap[year] = {};
    newsletterMap[year][month] = entry.path;
  });

  const handleDocumentClick = (pdfPath) => {
    if (pdfPath) {
      window.open(`${apiBase.replace('/api', '')}${pdfPath}`, "_blank");
    }
  };

  return (
    <div className={styles.document_rm}>
      {/* Monthly Newsletter */}
      <div className={styles.documet_row}>
        <div className={styles.documet_title}>
          <div>
            <h4>MONTHLY<br />NEWSLETTER</h4>
          </div>
          <img src={calendarIcon} alt="Calendar Icon" loading="lazy" />
        </div>
        <div className={styles.links_details}>
          <div className={styles.newsletter_container}>
            {Object.keys(monthsForYear).map((year) => (
              <div key={year}>
                <div className={styles.newsletter_year_row}>
                  <div className={styles.newsletter_year_label}>{year}</div>
                  <div className={styles.month_grid}>
                    {monthsForYear[year].map((month) => {
                      const path = newsletterMap[year]?.[month] || null;
                      const isAvailable = Boolean(path);
                      return (
                        <span
                          key={`${year}-${month}`}
                          onClick={() => isAvailable && handleDocumentClick(path)}
                          style={{
                            cursor: isAvailable ? "pointer" : "default",
                            opacity: isAvailable ? 1 : 0.5,
                            fontWeight: isAvailable ? 500 : "normal"
                          }}
                        >
                          {month.slice(0, 3)}
                        </span>
                      );
                    })}
                  </div>
                </div>
                {year !== Object.keys(monthsForYear).at(-1) && (
                  <div className={styles.newsletter_year_divider}></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <hr />

      {/* Legal Documents */}
      <div className={styles.documet_row}>
        <div className={styles.documet_title}>
          <div>
            <h4>LEGAL<br />DOCUMENTS</h4>
          </div>
          <img src={legalIcon} alt="Legal Icon" loading="lazy" />
        </div>
        <div className={styles.links_details}>
          {Legal_documents.map((doc, index) => (
            <React.Fragment key={doc.title}>
              <div>
                <p onClick={() => handleDocumentClick(doc.path)} style={{ cursor: "pointer" }}>
                  {doc.title}
                </p>
              </div>
              {index !== Legal_documents.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
      </div>
      <hr />

      {/* Company Brochure */}
      <div className={styles.documet_row}>
        <div className={styles.documet_title}>
          <div>
            <h4>COMPANY<br />BROCHURE</h4>
          </div>
          <img src={brochureIcon} alt="Brochure Icon" loading="lazy" />
        </div>
        <div className={styles.links_details}>
          {Company_brochure.map((brochure, index) => (
            <React.Fragment key={brochure.title}>
              <div>
                <p onClick={() => handleDocumentClick(brochure.path)} style={{ cursor: "pointer" }}>
                  {brochure.title}
                </p>
              </div>
              {index !== Company_brochure.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
      </div>
      <hr />

      {/* Annual Reports */}
      <div className={styles.documet_row}>
        <div className={styles.documet_title}>
          <div>
            <h4>ANNUAL<br />REPORTS</h4>
          </div>
          <img src={brochureIcon} alt="Reports Icon" loading="lazy" />
        </div>
        <div className={styles.links_details}>
          {Object.entries(Annual_reports).map(([title, path], index) => (
            <React.Fragment key={title}>
              <div>
                <p onClick={() => handleDocumentClick(path)} style={{ cursor: "pointer" }}>
                  {title}
                </p>
              </div>
              {index !== Object.entries(Annual_reports).length - 1 && <hr />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentRM;
